import { useState } from 'react'
import { supabase } from '../../supabaseClient'

export default function AdminLogin() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Please enter your email and password.')
      return
    }

    setLoading(true)
    setError(null)

    try {
      const { data, error: signInError } = await supabase.auth.signInWithPassword({ email, password })

      if (signInError) {
        setError(signInError.message)
        setLoading(false)
        return
      }

      if (!data?.user?.id) {
        setError('Login failed. Please try again.')
        setLoading(false)
        return
      }

      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('is_superadmin')
        .eq('id', data.user.id)
        .maybeSingle()

      if (profileError) {
        console.warn('Profile fetch error:', profileError.message)
        setError('Could not verify admin access. Please try again.')
        setLoading(false)
        return
      }

      if (!profile?.is_superadmin) {
        await supabase.auth.signOut()
        setError('Access denied. This area is for administrators only.')
        setLoading(false)
        return
      }

      window.location.href = '/admin'

    } catch (err) {
      console.error('Admin login error:', err)
      setError('An unexpected error occurred. Please try again.')
      setLoading(false)
    }
  }

  const inputStyle = {
    width: '100%', height: '44px', borderRadius: '10px',
    border: '1.5px solid #334155', padding: '0 14px',
    fontSize: '14px', color: 'white', outline: 'none',
    boxSizing: 'border-box', background: '#0F172A',
    fontFamily: 'Inter, sans-serif',
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0F172A',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '24px' }}>

        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '12px',
            background: 'linear-gradient(135deg, #2563EB, #1D4ED8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: '800', color: 'white', fontSize: '22px',
            margin: '0 auto 16px',
          }}>Q</div>
          <h1 style={{ fontSize: '20px', fontWeight: '800', color: 'white', margin: '0 0 4px' }}>
            QuoteFlow Admin
          </h1>
          <p style={{ fontSize: '13px', color: '#64748B', margin: 0 }}>
            Restricted access — administrators only
          </p>
        </div>

        <div style={{
          background: '#1E293B', borderRadius: '16px',
          border: '1px solid #334155', padding: '32px',
        }}>
          {error && (
            <div style={{
              background: '#FFF1F2', border: '1px solid #FECDD3',
              borderRadius: '8px', padding: '12px',
              color: '#BE123C', fontSize: '13px', marginBottom: '20px',
            }}>{error}</div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block', fontSize: '13px', fontWeight: '600',
              color: '#94A3B8', marginBottom: '6px',
            }}>Email address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block', fontSize: '13px', fontWeight: '600',
              color: '#94A3B8', marginBottom: '6px',
            }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              style={inputStyle}
            />
          </div>

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%', height: '44px', borderRadius: '10px',
              background: loading ? '#334155' : 'linear-gradient(135deg, #2563EB, #1D4ED8)',
              color: 'white', fontSize: '14px', fontWeight: '700',
              border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >{loading ? 'Signing in...' : 'Sign In to Admin'}</button>
        </div>
      </div>
    </div>
  )
}